import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _sortBy from "lodash/sortBy";
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

var createNameFromContentTypeId = function createNameFromContentTypeId(id, prefix) {
  return id.replace(prefix, "").replace(/([A-Z])/g, " $1").trim();
};

var createNormalizedId = function createNormalizedId(name) {
  var trimmedName = name.trim().replace(" ", "");

  if (trimmedName.length > 0) {
    var firstChar = trimmedName[0].toLowerCase();
    return firstChar + trimmedName.slice(1);
  }

  return name;
};

var groupFilters = function groupFilters(filters) {
  return filters.reduce(function (acc, filter) {
    var contentTypeId = filter.sys.contentType.sys.id;
    var normalizedName = createNameFromContentTypeId(contentTypeId, "customerStoryCategory");
    var normalizedId = createNormalizedId(normalizedName);

    if (!acc[normalizedId]) {
      acc[normalizedId] = {
        title: normalizedName,
        items: []
      };
    }

    acc[normalizedId].items.push({
      type: normalizedName,
      title: filter.fields.title,
      id: filter.sys.id
    });
    acc[normalizedId].items = _sortBy(acc[normalizedId].items, function (item) {
      return item.title.toLowerCase();
    });
    return acc;
  }, {});
};

export var fetchFilters = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(client) {
    var queries, responses, data, groupedFilters;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            queries = [client.get("/content/rawEntries/customerStoryCategoryUseCase"), client.get("/content/rawEntries/customerStoryCategoryIndustry"), client.get("/content/rawEntries/customerStoryCategoryRegion"), client.get("/content/rawEntries/customerStoryCategoryProducts")];
            _context.next = 3;
            return Promise.all(queries);

          case 3:
            responses = _context.sent;
            data = responses.flatMap(function (response) {
              return response.items;
            });
            groupedFilters = groupFilters(data);
            return _context.abrupt("return", groupedFilters);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFilters(_x) {
    return _ref.apply(this, arguments);
  };
}();